import { render, staticRenderFns } from "./OriginCreateUpdate.vue?vue&type=template&id=33ff6156&"
import script from "./OriginCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./OriginCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports